import React, { useState } from 'react';
import CardProfile from '../../../components/Profile/Card/';
import Snackbar from '../../../components/Snackbar';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { addSocialNetworksProfile } from '../../../store/actions/UserAction';
import TrophieModal from '../../../components/Modal/TrophieModal';
import SocialNetworks from '../../../components/Forms/Perfil/SocialNetworks';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { validationSocialNetwork } from '../../../utils/validations';
import './SocialNetworks.scss';

const Contact = ({role ,uid, addSocialNetworksProfile, socialNetworks, authClient, trophie, showLoading, hideLoading}) => {
  const [openTrophieModal, setOpenTrophieModal] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success'
  });

  const handleSnack = () => {
    setFeedbackMessage({
      open: true,
      message: 'Tus cambios se han guardado con éxito',
      variant: 'success'
    });
  }

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
    handleSnack()
  };

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    const arrayValues = Object.values(values)
    const boolValues = arrayValues.every(elem => elem)
    showLoading(); 
    setSubmitting(false);
    addSocialNetworksProfile(uid, values, boolValues)
      .then(res => {
        hideLoading();
        handleOpenTrophieModal()
        if (!boolValues) {
          handleSnack()
        }
    })
      .catch(error => {})
    };

    const handleCloseFeedbackMessage = () => {
      setFeedbackMessage({
        open: false,
        message: '',
        variant: 'success'
      });
    };
  
    let formValues ={}
    if (socialNetworks) {
      formValues = {
        linkedIn: socialNetworks.linkedIn,
        twitter: socialNetworks.twitter,
        facebook: socialNetworks.facebook,
        instagram: socialNetworks.instagram,
        youtube: socialNetworks.youtube,
      };
    } else {
      formValues = {
        linkedIn:'',
        twitter:'',
        facebook:'',
        instagram:'',
        youtube:'',
      };
    }
  
  return (
    <div className='socialNetworks'>

      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title='Redes sociales'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Ingresar tus redes sociales te da más presencia en el mundo digital.'
      />

      <CardProfile
        title="Redes sociales"
        subTitle={authClient.role && authClient.role === 'lawFirm' ?
          'Agrega las redes sociales del despacho para que los clientes puedan conocerlo y seguirlo.':
          'Agrega tus redes sociales como profesional para que los clientes puedan conocerte y seguirte.'
        }
        awardIcon
        status={authClient && authClient.awardPerfil.socialNetworks ? authClient.awardPerfil.socialNetworks : false}
      >
        <Formik
          initialValues={formValues}
          validationSchema={validationSocialNetwork}
          onSubmit={handleSubmit}
          render={props => (<SocialNetworks {...props}  />)}
        />
      </CardProfile>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  authClient: state.authClient,
  socialNetworks: state.authClient.socialNetworks,
  trophie: state.authClient.awardPerfil.socialNetworks,
});

const mapDispatchToProps = dispatch => ({
  addSocialNetworksProfile : (uid, values, boolValues) => dispatch(addSocialNetworksProfile(uid, values, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
}); 
 
export default connect(mapStateToProps, mapDispatchToProps)(Contact);
